import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1595df1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ai-locked__content" }
const _hoisted_2 = { class: "ai-locked__text" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "ai-locked__button__text" }

import { PropType } from 'vue';
import { storeToRefs } from 'pinia';
import { useCommonStore } from '@/store/common';

import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AiLocked',
  props: {
  style: {
    type: Object as PropType<any>,
    required: false,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



const { params } = storeToRefs(useCommonStore());

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock(AiTooltip, {
    location: "bottom",
    "content-class": "ai-locked__tooltip",
    top: true
  }, {
    top: _withCtx(() => [
      _createElementVNode("div", {
        class: "ai-locked",
        style: _normalizeStyle(props.style)
      }, [
        _createVNode(_component_inline_svg, {
          src: require('@/assets/icons/locked.svg')
        }, null, 8, ["src"])
      ], 4)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.locked-text')), 1),
        _createElementVNode("a", {
          href: `https://app.24ai.tech/${_unref(params)?.lang}`,
          target: "_blank",
          class: "ai-locked__button"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('common.go-to-app')), 1)
        ], 8, _hoisted_3)
      ])
    ]),
    _: 1
  }))
}
}

})